import React from "react";

interface CroppedSectionProps {
  fill?: string;
  animate?: boolean;
}
export default function CroppedSection(
  props: CroppedSectionProps
): React.JSX.Element {
  return props.animate ? (
    <svg fill={props.fill || "#fff"} viewBox="0 0 1440 392" width="100%">
      <path d="M 1234.7 181.521 L 1441 181.521 V 392 H 0 L 2 181.521 L 210.183 181.521 H 1234.7 Z">
        <animate
          attributeName="d"
          dur="1s"
          fill="freeze"
          from="M 1234.7 181.521 L 1441 181.521 V 392 H 0 L 0 181.521 L 210.183 181.521 H 1234.7 Z"
          to="M 1234.7 181.521 L 1441 0 V 392 H 0 L -3 398 L 210.183 181.521 H 1234.7 Z"
        />
      </path>
    </svg>
  ) : (
    <svg fill={props.fill || "#fff"} viewBox="0 0 1440 392" width="100%">
      <path d="M1234.7 181.521L1440 0V392H0L210.183 181.521H1234.7Z" />
    </svg>
  );
}
